import React from 'react';
import './style.css';

export default ({children}) => (
    <div className="IntroductionSection">
        <div className="content">
            <div className="IntroductionSection-content">
                <div>{children}</div>
            </div>
        </div>
    </div>
)


// WEBPACK FOOTER //
// ./src/common/sections/IntroductionSection/index.js